import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAssetsContext } from '../../context/AssetsContext';
import { Asset } from '../../state/types';

export const useAssetTableLogic = () => {
  const navigate = useNavigate();
  const { assets, selectedAssets, setSelectedAssets } = useAssetsContext();

  const [openModal, setOpenModal] = useState(false);
  const [modalAsset, setModalAsset] = useState<{ systemCode: string; assetInstanceId: string } | null>(null);
  const [thumbnailErrors, setThumbnailErrors] = useState<Record<string, boolean>>({});

  useEffect(() => {
    setThumbnailErrors({});
  }, [assets]);

  const handleRowClick = (asset: Asset) => {
    navigate(`/asset/${asset.systemCode}/${asset.assetInstanceId}`, { state: { asset } });
  };

  const handleThumbnailError = (assetId: string) => {
    setThumbnailErrors((prev) => ({ ...prev, [assetId]: true }));
  };

  const handle360Click = (event: React.MouseEvent, systemCode: string, assetInstanceId: string) => {
    event.stopPropagation();
    setModalAsset({ systemCode, assetInstanceId });
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalAsset(null);
  };

  const handleCheckboxClick = (event: React.MouseEvent, asset: Asset) => {
    event.stopPropagation();
    const isSelected = selectedAssets.some((selectedAsset) => selectedAsset.assetInstanceId === asset.assetInstanceId);
    const updatedSelection = isSelected
      ? selectedAssets.filter((selectedAsset) => selectedAsset.assetInstanceId !== asset.assetInstanceId)
      : [...selectedAssets, asset];

    setSelectedAssets(updatedSelection);
  };

  const handleSelectAllClick = () => {
    if (selectedAssets.length === assets.length) {
      setSelectedAssets([]);
    } else {
      setSelectedAssets(assets);
    }
  };

  const isSelected = (asset: Asset) => {
    return selectedAssets.some((selectedAsset) => selectedAsset.assetInstanceId === asset.assetInstanceId);
  };

  return {
    openModal,
    modalAsset,
    thumbnailErrors,
    handleRowClick,
    handleThumbnailError,
    handle360Click,
    handleCloseModal,
    handleCheckboxClick,
    handleSelectAllClick,
    isSelected,
    isAllSelected: selectedAssets.length > 0 && selectedAssets.length === assets.length,
    isIndeterminate: selectedAssets.length > 0 && selectedAssets.length < assets.length,
  };
};
